"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var evaluateOverlay_1 = require("./evaluateOverlay");

var evaluateSubtitleTrack_1 = require("./evaluateSubtitleTrack");

var evaluateVideoSource_1 = require("./evaluateVideoSource");

exports.evaluateScene = function (scene, variableDictionary) {
  var value = {
    id: scene.id,
    videoSource: evaluateVideoSource_1.evaluateVideoSource(scene.videoSource, variableDictionary)
  };
  if (utils_1.hasValue(scene.overlays)) value.overlays = scene.overlays.map(function (overlay) {
    return evaluateOverlay_1.evaluateOverlay(overlay, variableDictionary);
  });
  if (utils_1.hasValue(scene.subtitles)) value.subtitles = scene.subtitles.map(function (subtitleTrack) {
    return evaluateSubtitleTrack_1.evaluateSubtitleTrack(subtitleTrack, variableDictionary);
  });
  return value;
};